import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		WatchlistedCategory: [],
		RequestType: [],
	},
	filter: {
		WatchlistedVehiclesCategoryId: null as number | null,
		RequestTypeId: null as number | null,
	},
	tableSetting: {},
	localState: {
		Remark: null as string | null,
	},

	rowDetail: null,
	extraActions: {

	},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
